export const conditionReportPermissions = {
    FREE_ACCESS:{
        key: 'Vehicle.ConditionReport.FreeAccess',
        name: 'Condition Report Free Access',
    },
    COLLECTIBLE: {
        key: 'Vehicle.ConditionReport.Collectible',
        name: 'Condition Report Collectible',
    }
}